import CartPanelExperienceTile from './CartPanelExperienceTile'
import CartPanelFlightTile from './CartPanelFlightTile'
import CartPanelHotelTileDispatcher from './CartPanelHotelTileDispatcher'
import type { CartPanelAccommodationItem, CartPanelExperienceItem, CartPanelFlightItem, CartPanelItem } from '../hooks/useCartPanelItems'

interface Props {
  item: CartPanelItem
  onToggleInclude: (item: CartPanelItem) => void
  onSetDates: () => void
  onChooseTickets: (item: CartPanelExperienceItem) => void
  onChooseDate: (item: CartPanelExperienceItem) => void
  onChooseTime: (item: CartPanelExperienceItem) => void
  onChooseDifferentTickets: (item: CartPanelExperienceItem) => void
  onChooseFlight: (item: CartPanelFlightItem) => void
  onRefreshFlight: (item: CartPanelFlightItem) => void
  onChangeFlight: (item: CartPanelFlightItem) => void
  onViewFlightDetails: (item: CartPanelFlightItem) => void
  refreshingFlightKey: string | undefined
  onDelete: (item: CartPanelItem) => void
  isStreaming: boolean
}

function isAccommodationItem(item: CartPanelItem): item is CartPanelAccommodationItem {
  return item.productType === 'accommodation'
}

function isFlightItem(item: CartPanelItem): item is CartPanelFlightItem {
  return item.productType === 'flight'
}

function CartPanelItemDispatcher({
  item,
  onToggleInclude,
  onSetDates,
  onChooseTickets,
  onChooseDate,
  onChooseTime,
  onChooseDifferentTickets,
  onChooseFlight,
  onRefreshFlight,
  onChangeFlight,
  onViewFlightDetails,
  refreshingFlightKey,
  onDelete,
  isStreaming,
}: Props) {
  if (isAccommodationItem(item)) {
    return (
      <CartPanelHotelTileDispatcher
        item={item}
        onToggleInclude={onToggleInclude}
        onSetDates={onSetDates}
        onDelete={onDelete}
        isStreaming={isStreaming}
      />
    )
  }

  if (isFlightItem(item)) {
    return (
      <CartPanelFlightTile
        item={item}
        onToggleInclude={onToggleInclude}
        onChooseFlight={onChooseFlight}
        onRefreshFlight={onRefreshFlight}
        onChangeFlight={onChangeFlight}
        onViewFlightDetails={onViewFlightDetails}
        onDelete={onDelete}
        isStreaming={isStreaming}
        isRefreshing={item.key === refreshingFlightKey}
      />
    )
  }

  return (
    <CartPanelExperienceTile
      item={item}
      onToggleInclude={onToggleInclude}
      onChooseTickets={onChooseTickets}
      onChooseDate={onChooseDate}
      onChooseTime={onChooseTime}
      onChooseDifferentTickets={onChooseDifferentTickets}
      onDelete={onDelete}
      isStreaming={isStreaming}
    />
  )
}

export default CartPanelItemDispatcher
